import React, { useEffect,useState } from 'react';
import _set from 'lodash/set';

import Table from 'components/customTable';

import LineChart from '../../../components/lineChart';
import { ChartService } from '../../../services/chartService';

const useInnerWidth = () => {
  const [innerWidth, setInnerWidth] = useState(0);
  useEffect(() => {
    function handleResize() {
      setInnerWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return innerWidth;
};

const DATASETS_PROPS = {
  borderWidth: 2,
  pointRadius: 0,
  hitRadius: 3,
  hoverRadius: 3,
  hoverBorderWidth: 1,
  backgroundColor: 'rgba(0, 0, 0, 0)',
};

const UnemploymentRate = ({ jobTitle, employmentOverTime, unemploymentRateContentBlurb }) => {
  const innerWidth = useInnerWidth();
  const labels = employmentOverTime.map((item) => item.year);
  const { maxTicksLimit, xMin } = getInitialOptions();
  const datasets = [
    {
      ...DATASETS_PROPS,
      data: employmentOverTime.map((item) => item.unemploymentRate),
      label: 'Unemployment rate',
      datasetKeyProvider: 'Unemploymentstatus',
      borderColor: '#26A69A',
      pointBackgroundColor: '#26A69A',
    },
  ];
  const tableData = (employmentOverTime ?? []).map((x) => ({
    ...x,
    unemploymentRateDisplay: (x.unemploymentRate * 100).toFixed(2) + '%',
  }));

  const options = {
    onResize: handleChartResize,
    tooltips: {
      callbacks: {
        label(tooltipItem, data) {
          const { value, datasetIndex } = tooltipItem;
          return `${data.datasets[datasetIndex].label}: <strong>${(value * 100).toFixed(
            1
          )}%</strong>`;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            maxTicksLimit,
            callback(value) {
              return `${(value * 100).toFixed(1)}%`;
            },
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            xMin,
            maxTicksLimit,
          },
        },
      ],
    },
  };

  function getInitialOptions() {
    if (innerWidth < 768) {
      return { maxTicksLimit: 6, xMin: labels[1] };
    } else {
      return { maxTicksLimit: 11, xMin: labels[0] };
    }
  }

  function handleChartResize(chartInstance) {
    const { maxTicksLimit, xMin } = getInitialOptions();
    _set(chartInstance, 'options.scales.yAxes[0].ticks.maxTicksLimit', maxTicksLimit);
    _set(chartInstance, 'options.scales.xAxes[0].ticks.maxTicksLimit', maxTicksLimit + 1);
    _set(chartInstance, 'options.scales.xAxes[0].ticks.min', xMin);
  }

  const lineChartProps = () => {
    return {
      ...ChartService.setupLineChart({
        labels,
        datasets,
        options,
      }),
    };
  };

  return (
    <section id="unemployment-rate">
      <h3 className="cmpSectionh4 mb-3">{`${jobTitle} Unemployment Rate Over Time`}</h3>

      {unemploymentRateContentBlurb && unemploymentRateContentBlurb.content && (
        <div
          className="content-blurb"
          dangerouslySetInnerHTML={{ __html: unemploymentRateContentBlurb.content }}
        />
      )}

      <LineChart {...lineChartProps()} />
      <div className="mb-0 z-mt-48">
        <Table
          columnConfig={{
            year: {
              columnName: 'Year',
              defaultSortDirection: 'desc',
            },
            unemploymentRateDisplay: {
              columnName: jobTitle + ' Unemployment Rate',
              customSortByField: 'unemploymentRate',
              // defaultSortDirection: 'desc'
            },
          }}
          bodyData={tableData}
          defaultRowsDisplay={99}
          tableHeaderTitleContent={
            <h3 className="zp-title-h3 text-capitalize z-mb-24">{`${jobTitle} Unemployment Rate By Year`}</h3>
          }
        />
      </div>
    </section>
  );
};

export default UnemploymentRate;
